<div class="customers">
  <h2 class="customers__title">{{ 'customers.pageHeader' | translate }}</h2>
  @if (customers().length > 0 || customersLoading()) {
    <div class="customers__wrapper">
      <div class="table-container">
        <div class="table-heading">
          <app-search-field
            [placeholder]="'customers.table.placeholders.search' | translate"
            [formControl]="parentSearchControl"
          />
          <div class="customers__buttons">
            <button
              (click)="openCreateCustomerDialog()"
              mat-button
              color="primary"
              class="customers__add-customer-btn add-button"
            >
              {{ 'customers.table.buttons.addCustomer' | translate }}
              <mat-icon class="add-icon">add</mat-icon>
            </button>
          </div>
        </div>

        <div class="table-wrapper">
          <table
            mat-table
            [dataSource]="customersLoading() ? skeletonRows() : customers()"
            class="full-width-table"
          >
            @for (column of customersTableColumnsConfig(); track column.key) {
              <ng-container [matColumnDef]="column.key">
                <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
                  <div class="header-cell__wrapper">
                    <span>{{ column.label | translate }}</span>
                    @if (column.sortable) {
                      <app-icon class="icon" [icon]="iconName.SORTABLE_ARROW" />
                    }
                  </div>
                </th>
                <td [class]="column.cellClass" mat-cell *matCellDef="let customer">
                  @if (customersLoading()) {
                    @if (column.key === customerColumnKey.Actions) {
                      <div class="skeleton skeleton--icon"></div>
                    } @else {
                      <div class="skeleton skeleton--text"></div>
                    }
                  } @else {
                    @if (column.key === customerColumnKey.CustomerFirstName) {
                      {{ customer.firstName }} {{ customer.lastName }}
                    } @else if (column.key === customerColumnKey.Status) {
                      <span
                        class="status"
                        [class.active]="customer.isActive"
                        [class.inactive]="!customer.isActive"
                      >
                        {{
                          customer.isActive
                            ? ('customers.table.status.active' | translate)
                            : ('customers.table.status.deactivated' | translate)
                        }}
                      </span>
                    } @else if (column.key === customerColumnKey.Actions) {
                      <button
                        class="cell"
                        mat-icon-button
                        [matMenuTriggerFor]="actionsMenu"
                        #menuTrigger="matMenuTrigger"
                      >
                        <mat-icon [class.menu-open]="menuTrigger.menuOpen">more_vert</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" panelClass="actions-menu">
                        <button (click)="openViewCustomerDialog(customer)" class="action-btn">
                          <app-icon class="icon-customer" [icon]="iconName.VIEW_ORDER" />
                          <span>
                            {{ 'customers.table.actions.viewCustomer' | translate }}
                          </span>
                        </button>
                        <button
                          class="action-btn"
                          (click)="openEditCustomerDialog(customer, menuTrigger)"
                        >
                          <app-icon class="icon-customer" [icon]="iconName.PENCIL" />
                          <span>
                            {{ 'customers.table.actions.editCustomer' | translate }}
                          </span>
                        </button>
                      </mat-menu>
                    } @else {
                      {{ customer[column.key] }}
                    }
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="customersTableColumnKeys"></tr>
            <tr mat-row *matRowDef="let row; columns: customersTableColumnKeys"></tr>
          </table>
        </div>
      </div>
      <div class="customers__footer footer">
        @if (showPagination()) {
          <app-table-pagination
            [pagination]="customersPagination()"
            (pageChange)="handlePageChange($event)"
            (pageSizeChange)="handlePageSizeChange($event)"
          />
        }
      </div>
    </div>
  } @else {
    @if (parentSearchControl.value) {
      <div class="customers__wrapper">
        <div class="table-container">
          <div class="table-heading">
            <app-search-field
              [placeholder]="'customers.table.placeholders.search' | translate"
              [formControl]="parentSearchControl"
            />
            <div class="customers__buttons">
              <button
                (click)="openCreateCustomerDialog()"
                mat-button
                color="primary"
                class="customers__add-customer-btn add-button"
              >
                {{ 'customers.table.buttons.addCustomer' | translate }}
                <mat-icon class="add-icon">add</mat-icon>
              </button>
            </div>
          </div>

          <div class="empty-state empty-state--search">
            <h3 class="empty-state__title">
              {{ 'customers.table.emptySearch.searchTitle' | translate }}
            </h3>
            <p class="empty-state__description">
              {{
                'customers.table.emptySearch.searchDesc'
                  | translate: { value: parentSearchControl.value }
              }}
            </p>
          </div>

        </div>
      </div>
    } @else {
      <div class="empty-customers">
        <h2 class="empty-customers__title">
          {{ 'customers.table.emptyTable.noItemsTitle' | translate }}
        </h2>
        <span class="empty-customers__description">
          {{ 'customers.table.emptyTable.noItemsDescription' | translate }}
        </span>
        <button
          (click)="openCreateCustomerDialog()"
          mat-button
          color="primary"
          class="customers__add-customer-btn"
        >
          {{ 'customers.table.emptyTable.addCustomer' | translate }}
          <mat-icon class="add-icon">add</mat-icon>
        </button>
      </div>
    }
  }
</div>
